import React from 'react'
import { ScaledRecipe } from '@/api/types'
import { Link } from '@tanstack/react-router'
import { CollapsibleSection } from '@/components/CollapsibleSection/CollapsibleSection'
import { faExternalLink } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { HeuristicScores } from '../HeuristicScores/HeuristicScores'
import { Spinner } from '@/components/Spinner'
import { t } from 'i18next'
import { getTotalHeuristicsScore } from '@/utils/heuristics'

type Props = {
  scaledRecipes?: Array<ScaledRecipe>
  onClick?: () => void
}

export function RecipeReplacements({ scaledRecipes, onClick }: Props) {
  return (
    <CollapsibleSection
      label={t('mealPlan.replacements')}
      labelStyle={{ marginTop: '1rem', color: '#2c3e50' }}
      onClick={onClick}>
      {scaledRecipes ? (
        <div style={{ marginTop: '0.5rem', paddingLeft: '20px' }}>
          {scaledRecipes.map((sr) => (
            <div key={sr.recipe?.name} style={{ padding: '2px 0', display: 'flex', gap: '5px' }}>
              {sr.heuristicScores ? (
                <CollapsibleSection
                  label={`${sr.recipe.name} (score: ${getTotalHeuristicsScore(sr.heuristicScores)})`}
                  labelStyle={{ fontSize: '14px' }}>
                  <HeuristicScores heuristicScores={sr.heuristicScores} />
                </CollapsibleSection>
              ) : (
                <span>{sr.recipe.name}</span>
              )}
              <Link
                to="/recipes/$recipeId"
                params={{ recipeId: sr.recipe.idRecipe.toString() }}
                style={{ color: '#2c3e50', textDecoration: 'underline' }}>
                <FontAwesomeIcon
                  icon={faExternalLink}
                  size="xs"
                  color="var(--highlight-background)"
                />
              </Link>
            </div>
          ))}
        </div>
      ) : (
        <Spinner />
      )}
    </CollapsibleSection>
  )
}
